import dynamic from 'next/dynamic';
import { SearchBarProps } from './types';

export const DynamicSearchBar = dynamic<SearchBarProps<any>>(() => import('./SearchBar'), { ssr: false });

export default DynamicSearchBar;
